<script>

import { slide,crossfade } from 'svelte/transition';
import { cubicInOut } from 'svelte/easing';
//inspired by https://svelte.dev/repl/69e1a65fe10f4bbba3f32954825d32e4?version=3.23.1 from GrygrFlzr
const [send,receive]  = crossfade({
	delay: 0,
	duration: 300,
	fallback: slide,
	easing: cubicInOut
	});

/*import { BarcodeDetectorPolyfill } from '@undecaf/barcode-detector-polyfill'
try {
	window['BarcodeDetector'].getSupportedFormats();
	console.log('BarcodeDetector: using native');
	}
catch (err){
	console.log('BarcodeDetector: using polyfill');
	window['BarcodeDetector'] = BarcodeDetectorPolyfill;
	}
const detector = new BarcodeDetector({ formats: ['code_128'] });*/
//const barcodes = await detector.detect(source)

import Fa from 'svelte-fa'
import { faExclamationCircle, faAngleDoubleRight, faAngleDoubleLeft, faCheck, faHome, faThumbsUp, faRedo, faCamera} from '@fortawesome/free-solid-svg-icons'

import app from '../web_feathers.js';
const {perms} = app;//destructure so we can watch it.

const sim_activations = app.service('sim_activations_form');
const sim_orders = app.service('sim_orders');
const tokenTranzila = app.service('token-tranzila');
const checkActive = app.service('check-active');


import Spinner from 'svelte-spinner';

import {push, replace, location, querystring } from 'svelte-spa-router';
if($location=='/') replace('/1');//default to page one.

const pageTitles={
	 '/1': '1-choose-plan'
	,'/2': '2-new-or-porting'
	,'/3': '3-virtual-number'
	,'/4': '4-SIM'
	,'/5': '5-email&name'
	,'/6': '6-verify_email'
	,'/7': '7-pay'
	,'/8': '8-success'
	}
$: recordPage(pageTitles[$location]);
function recordPage(url){
	if(!url) return;
	if(typeof hj!==undefined) hj && hj('stateChange', 'sim-activate.html#/'+url);
	if(typeof gtag!==undefined) gtag && gtag('config', 'UA-168570359-1', { 'page_path': 'sim-activate.html#/'+url});
	}

import { writable, get } from 'svelte/store'; //via https://github.com/higsch/higsch.me/blob/master/content/post/2019-06-21-svelte-local-storage.md
const createWritableStore = (key, startValue) => {
  const { subscribe, set } = writable(startValue);
	return {
    subscribe,
    set,
    useLocalStorage: () => {
      const json = localStorage.getItem(key);
      if (json) {
        set(JSON.parse(json));
      }
      
      subscribe(current => {
        localStorage.setItem(key, JSON.stringify(current));
      });
    }
  };
}
const form_activate = createWritableStore('form_activate', {});
form_activate.useLocalStorage();

if($location=='/clear') {//clear all cache for customer
	clearCache();
	push('/1');//return to page one.
	}
if($location=='/resetid') {//reset the order ID so he makes a new order with the currently saved information
	resetID();
	push('/1');//return to page one.
	}
function resetID(){
	$form_activate.id=undefined;
	}

//var form = {};
var errors=[];
var loading=false;

function getCookie(cname) {//https://www.w3schools.com/js/js_cookies.asp
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
var refer = getCookie('refer') || null;

var showLoginLink=false;
//Step 1: Choose a plan.
function choosePlan(plan){
	$form_activate.plan=plan;
	if(plan=='70gb') {
		$form_activate.bill=59;
		$form_activate.dataGB=70;
		}
	else if(plan=='100gb') {
		$form_activate.bill=73;
		$form_activate.dataGB=100;
		}
	else if(plan=='150gb') {
		$form_activate.bill=79;
		$form_activate.dataGB=150;
		}
	else if(plan=='5G-200gb') {
		$form_activate.bill=99;
		$form_activate.dataGB=200;
		}
	else if(plan=='kosher') {
		$form_activate.bill=64;
		$form_activate.dataGB=0;
		}
	}
function submitPlan(){
	errors=[];
	if(!$form_activate.plan) return errors=['You must choose a plan before continuing.'];
	//saveUserData.set(form);
	push('/2');
	}
function showCountries(){
	recordPage('show-country-list');
	Swal.fire({
		title: 'List of additional countries - landlines only',
		html: '<div style="overflow-x:auto;"><table border=1 cellspacing=0>'+
			'<tr><td>Argentina</td><td>Australia</td><td>Austria</td><td>Belgium</td></tr>'+
		'<tr><td>China</td><td>Cyprus</td><td>Denmark</td><td>France</td></tr>'+
		'<tr><td>Germany</td><td>Greece</td><td>Hong Kong</td><td>Hungary</td></tr>'+
		'<tr><td>Ireland</td><td>Italy</td><td>Japan</td><td>Luxembourg</td></tr>'+
		'<tr><td>Malta</td><td>Netherlands</td><td>New Zealand</td><td>Norway</td></tr>'+
		'<tr><td>Poland</td><td>Portugal</td><td>Romania</td><td>Russia</td></tr>'+
		'<tr><td>Singapore</td><td>South Africa (country)</td><td>Spain</td><td>Sweden</td></tr>'+
		'<tr><td>Switzerland</td><td>Taiwan</td><td>Turkey</td><td>United Kingdom</td></tr>'+
		'<tr><td>Vatican</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>'+
		'</table></div>',
		icon: '',
		})
	}
//Step 2: Are you porting?
let israelNumberValid=null;
let showSupportLinksPort=false;
let showSupportLinksSIM=false;
function checkisraelNumberStrict(){
	israelNumberValid = israelPhoneMobileValidate($form_activate.porting);
	}
function checkisraelNumberLoose(){//sometimes we can return results even before a blur, for faster feedback
	//If we're  might be done. So check it, but only return if it's valid.
	//console.log('checking',$form_activate.porting,israelPhoneMobileValidate($form_activate.porting))
	if($form_activate.porting && israelPhoneMobileValidate($form_activate.porting)) return israelNumberValid=true;

	//Once state is showing, check on every key-up in case we change something. Don't show a phantom success!
	if(israelNumberValid!==null) return israelNumberValid = israelPhoneMobileValidate($form_activate.sim);
	}

import { israelPhoneMobileValidate, israelPhoneMobileNormalize, israelPhoneValidateMobileKosher } from '../common_israel_mobiles.js';
async function submitPorting(){
	errors=[];
	showSupportLinksPort=false;
	showLoginLink=false;
	if($form_activate.porting_form==undefined) return errors=['You must choose if you are getting a new number or porting an existing number.'];
	if($form_activate.porting_form && !israelPhoneMobileValidate($form_activate.porting)) return errors=['To keep your existing Israeli mobile number, you must enter the valid phone number.'];
	if($form_activate.porting_form && israelPhoneValidateMobileKosher($form_activate.porting) && $form_activate.plan!="kosher") return errors=['In order to port a kosher number, you must choose the kosher plan.'];
	if($form_activate.porting_form && !israelPhoneValidateMobileKosher($form_activate.porting) && $form_activate.plan=="kosher") return errors=['In order to port a non-kosher phone number, you must choose a non-kosher plan.'];
	if($form_activate.porting_form==false) $form_activate.porting='';

	if($form_activate.porting) {
		const isActive = await checkActive.find({query:{phone:$form_activate.porting}}).catch(err=>errors=[err.message]);
		if(errors.length) return errors;

		if(isActive) {
			showSupportLinksPort=true;
			showLoginLink=true;
			errors=['Woops! This phone number is already a FreedomHot account. Please login to make changes to your account:'];
			//if(isActive.frozen) errors= [...errors, 'This account is frozen: please login to re-activate it.'];
			//if(isActive.data!=$form_activate.dataGB) errors= [...errors, 'If you\'re trying to change your data plan, please login to your account.'];
			}
		}
	if(errors.length) return errors;

	errors=[];
	push('/3');
	}

//Step 3: Want a USA number?
function submitVirtualNumber(){
	if($form_activate.usa_number_wanted==undefined) return errors=['You must choose if you want a USA number or not.'];
	errors=[];
	push('/4');
	}

//Step 4: Enter SIM number
let simValid=null;
import simhotvalidate from '../common_sim_hot_validate.js';
$: sim5 = $form_activate.sim && $form_activate.sim.substr(0,5);
$: error_sim_usa=	$form_activate.sim && $form_activate.sim.substr(0,4)=="8901" ? 'This appears to be a USA SIM card.' : '' ;
$: error_sim_canada=$form_activate.sim && sim5=="89302" ? 'This appears to be a Canada SIM card.' : '' ;
$: error_sim_israel=$form_activate.sim && (
	($form_activate.sim.length>=7 && sim5=="89972" && $form_activate.sim.substr(0,7)!="8997207") 
	||($form_activate.sim.length>=6 && sim5=="89972" && $form_activate.sim.substr(0,6)!="899720")) ? 'This is an Israeli SIM, but is not from Hot Mobile.' : '' ;


async function DecodePictureOfSIM(){
	/*
	<input
    type="file"
    id="environment"
    capture="environment"
    accept="image/*"
    bind:files={pictureOfSIM}
  	>*/
	const result = await Swal.fire({
		input: 'file',
		inputAttributes: {
			//name:"upload[]",
			//id:"fileToUpload",
			capture: "environment",
			accept: "image/*"
			},
		showCloseButton: true,
		showCancelButton: true
		});

	if(!result.isConfirmed) return;
	const pictureOfSIM = result.value;

	//let preview = new FileReader();
    //preview.readAsDataURL(pictureOfSIM);

	console.log(pictureOfSIM);

	//var file = pictureOfSIM[0];

	var barcodes = await detector.detect(pictureOfSIM);
	barcodes = Object.values(barcodes);
	console.log('is array',Array.isArray(barcodes));
	console.log(barcodes);
	//let keys = Object.keys(barcodes);
	//console.log(barcodes);
	barcodes.every(async function(val){
		//let val = barcodes[key];
		//console.log(val);
		if(val.rawValue && val.format=='code_128' && val.rawValue.startsWith('89972')) {
			$form_activate.sim=val.rawValue;
			console.log('!! found ',val.rawValue)
			await tick();
			checkSimStrict();
			return false;//we're done 
			}
		return true;
		})
	}
function checkSimStrict(){
	simValid = simhotvalidate($form_activate.sim);
	}
function checkSimLoose(){//sometimes we can return results even before a blur, for faster feedback
	//if done typing, i.e. all 19 digits
	if($form_activate.sim && $form_activate.sim.length==19) return simValid = simhotvalidate($form_activate.sim);
	
	//12 digits -- might be done. So check it, but only return if it's valid.
	if($form_activate.sim && $form_activate.sim.length==12 && simhotvalidate($form_activate.sim)) return simValid=true;

	//Once state is showing, check on every key-up in case we change something. Don't show a phantom success!
	if(simValid!==null) return simValid = simhotvalidate($form_activate.sim);
	}

function onlyNumbers(evt) { 
	// Only ASCII charactar in that range allowed 
	var ASCIICode = (evt.which) ? evt.which : evt.keyCode 
	if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return evt.preventDefault();
	}
function onlyNumbersSeparator(evt) { 
	// Only ASCII charactar in that range allowed 
	var ASCIICode = (evt.which) ? evt.which : evt.keyCode 
	if (ASCIICode==45) return true;//allow dash
	if (ASCIICode==32) return true;//allow space
	if (ASCIICode==43) return true;//allow + for start
	if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return evt.preventDefault();
	}

async function submitSIM(event){
	if(event.altKey && showLoginLink) {//TEST for avi: proceed despite error
		errors=[];
		push('/5');
		return;
		}
	errors=[];
	showSupportLinksSIM=false;
	showLoginLink=false;
	if(event.altKey) {//TEST for avi: fill out data to let us move on. Test we didn't lose our data, too.
		$form_activate.sim='8997207104162782379';
		simValid=true;
		event.preventDefault();
		}
	if(!simhotvalidate($form_activate.sim)) return errors=['SIM Card is invalid - please ensure you have an Israel Hot Mobile SIM card.<br>If you don\'t have one you can <a href="/sim-order.html"> order one here</a>.'];

	const simError=compare_sim_and_plan($form_activate.sim,$form_activate.plan);
	if(simError) return errors = [...errors, simError];



	const isActive = await checkActive.find({query:{sim:$form_activate.sim}}).catch(err=>errors=[err.message]);
	if(errors.length) return errors;

	if(isActive) {
		showSupportLinksSIM=true;
		showLoginLink=true;
		errors=['Woops! This SIM is already active with FreedomHot. Please login to make changes to your account:'];
		//if(isActive.frozen) errors= [...errors, 'This account is frozen: please login to re-activate it.'];
		//if(isActive.data!=$form_activate.dataGB) errors= [...errors, 'If you\'re trying to change your data plan, please login to your account.'];
		}
	if(errors.length) return errors;

	push('/5');
	}


//Step 5: Customer name and Email -- send verification code
import Mailcheck from 'mailcheck/src/mailcheck';
var emailSuggestion;
function checkEmailAddress(){
	Mailcheck.run({email: $form_activate.email,
		suggested: function(suggestion) {
			emailSuggestion=suggestion;
			}
		, empty: function(suggestion) {
			emailSuggestion=null;
			}
		});
	}
function setEmail(){
	$form_activate.email = emailSuggestion.full;
	emailSuggestion=null;
	}
async function submitEmailWithoutVerification(event){
	//need to verify on the sever side, too, that we're really an admin.
	}
async function submitEmail(event){
	if(event.altKey && showLoginLink) {//TEST for avi: proceed despite error
		errors=[];
		push('/6');
		return;
		}

	showLoginLink=false;
	var schema={//don't use until later, after yup is loaded.
		plan:				yup.string().required().oneOf(['70gb','100gb','150gb','5G-200gb','kosher'])
		,sim:				yup.string().required().test('valid SIM', 'SIM Card Number is Invalid', simhotvalidate)
		,Customer_Name:		yup.string().required().trim()
		,email:				yup.string().required().trim().email()
		,porting_form:		yup.boolean().required()
		};
	//normalize number before submitting
	if(!$form_activate.porting_form) $form_activate.porting='';
	if($form_activate.porting) $form_activate.porting=israelPhoneMobileNormalize($form_activate.porting);

	//console.log($form_activate);
	errors=[];
	
	if(event.altKey) {//TEST for avi: fill out data to let us move on. Test we didn't lose our data, too.
		//don't clobber anything
		if(!$form_activate.email) $form_activate.email = 'natisamet@gmail.com';
		if(!$form_activate.Customer_Name) $form_activate.Customer_Name = 'Nati Samet'

		//previous pages, in case we navigated directly here.
		if(!$form_activate.plan) $form_activate.plan='70gb';
		if(!$form_activate.sim) $form_activate.sim='8997207104162782379';
		if(!$form_activate.porting_form) $form_activate.porting_form=false;
		}

	await yup.object().shape(schema).validate($form_activate, {abortEarly:false}).catch(function(err){
			//console.log(err);
			errors = err.errors.map(function(message){
				//SIM_Card_Needed_Count must be one of the following values: 1, 2, 1-kosher, 2-kosher, 1-sim&1-kosher
				//make it more user friendly, "SIM Card Needed Count"
				message = message.split(' ');
				message[0] = message[0].replace(/_/g,' ');
				message = message.join(' ');
				return message;
				});
			})
	if(errors.find(s=>s.includes('can\'t modify')) || errors.find(s=>s.includes('Please login'))) {//You can't modify this activation request after submitting payment
		//https://github.com/freedomhot/freedomhot/issues/36
		//It looks like you've already submitted payment for this activation request.
		//Try logging in to your account to see if it's active.
		//But if you're sure this a new activation, click here to submit this as a new activation. //DO a reset ID and put them back to page 1 to check SIM and phone number for already exists.
		showLoginLink=true;
		//do a resetID and move back to the first page.
		}
	const simError=compare_sim_and_plan($form_activate.sim,$form_activate.plan);
	if(simError) return errors = [...errors, simError];

	if(errors.length) return; //we had client side validation errors

	loading=true;

	var result;
	if($form_activate.id) result= await sim_activations.patch($form_activate.id, $form_activate)
		.catch(function(err){
			console.error(err.message);
			errors=[err.message];
			if(err.message.includes('Please login')) showLoginLink=true;
			if(err.message.includes('can\'t modify')) {
				resetID();
				errors.push('Submitting again will create a NEW activation request.')
				}
			});
	else result= await sim_activations.create({...$form_activate, referred_by: refer})
		.catch(function(err){
			console.error(err.message);
			errors=[err.message];
			});
	loading=false;
	if(errors.length) return; //we had server side validation errors
	//$form_activate={};//reset the form - @TODO -- we really don't want any more editing?
	$form_activate.id = result.id; //save the ID number for later.
	if(result.email_verified) return push('/7'); //email is verified, skip asking for verification code.
	push('/6');
	}

const kosherStart = ['8997207194','194'];
function compare_sim_and_plan(sim,plan){
	//8997207194100869867 -- kosher
	if(!sim || !plan) return null; //nothing to discuss yet, we have other errors

	const isKosherSim = sim.startsWith(kosherStart[0]) || sim.startsWith(kosherStart[1]);
	const isKosherPlan = plan=='kosher';

	if(isKosherPlan!=isKosherSim) {
		if(isKosherSim) return 'You are using a kosher SIM, you must pick the kosher plan.';
		else return 'You are using a non-kosher SIM, you must pick a non-kosher plan.';
		}
	return null;
	}

//step 6: check verification code was recieved
let verification_code;
async function submitVerification(){
	errors=[];
	//console.log('in submit function',$form_activate.id);
	if(!verification_code || verification_code>9999) return errors=['Please enter your 4 digit confirmation code.'];
	if(!$form_activate.id) return errors=['Sorry, you aren\'t in the middle of an order. Please restart your order.'];
	var result= await sim_activations.patch($form_activate.id, {verification_code:verification_code, email_verified:true,action: 'verify_email'})
		.catch(function(err){
			console.error(err.message);
			errors=[err.message];
			if(err.message.includes('can\'t modify')) {
				resetID();
				errors.push('Submitting again will create a NEW activation request.')
				}
			});
	if(errors.length) return;
	verification_code=null;

	if(result.email_verified) return push('/7');
	errors=['Please enter the PIN you received by email to continue.'];
	}

//$: console.log($form_activate)

//step 7: collect credit billing information
import CreditCardForm from '../creditCardEntry.svelte';
import { tick } from 'svelte';

var credit_card_valid;
var credit_card={};
var success={};
let ask_security_code=false;//if we get a tranzila 006 error then try asking for the security code
let manualTranzilaToken=null;
let manualMyOfficeGuyCustomer=null;

function getQueryVariable(query,variable){ //via https://css-tricks.com/snippets/javascript/get-url-variables/
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if(pair[0] == variable){return pair[1];}
		}
	return false;
	}

let import_order;
$: if($perms && $perms.includes('admin') && $querystring.includes('import_order')) doImportOrder();
async function doImportOrder(){
	let order=getQueryVariable($querystring,'import_order');
	if(!order) return console.log('no order to import');
	if(import_order==order) return console.log('already imported this order, query string changed?');
	import_order=order;//store it so we don't clobber our own information
	console.log('importing sim order information, clobbering current order', import_order);
	const result = await sim_orders.get(import_order);
	console.log(result);
	$form_activate={};
	$form_activate.Customer_Name=result.Customer_Name;
	$form_activate.email= result.email;
	manualTranzilaToken=result.TranzilaTK;
	manualMyOfficeGuyCustomer=result.bestfone_mog;

	credit_card.expiry_month = result.cc_expiry.slice(0,2);
	credit_card.expiry_year  = result.cc_expiry.slice(2,4);
	if(result.comments) $form_activate.sim=result.comments;
	}

$: if($perms && $perms.includes('admin') && $querystring.includes('continue_activation')) doContinueActivation();
const fieldsToImport=['id','Customer_Name','email','plan','porting','sim','usa_number_location','usa_number_wanted','security_code'];//can't really import any of the credit card information, we do weird processing and anyway it shouldn't be saved yet!
async function doContinueActivation(){
	let id=getQueryVariable($querystring,'continue_activation');
	if(!id) return console.log('no activation to continue');
	console.log('importing sim activation information, clobbering current information', id);
	const result = await sim_activations.get(id);
	console.log(result);

	//import only `fieldsToImport` so we can actually save it
	$form_activate={};
	for(let field of fieldsToImport) {
		if(field in result) $form_activate[field]=result[field];
		}
	$form_activate.porting_form = !!result.porting;
	}

var termsShake=false
var termsError=false;
async function submitPayment(){
	termsShake=false;
	if(!$form_activate.terms) {
		errors=['You must agree to the terms before continuing.'];
		termsError=true;
		termsShake=true;
		return;
		}
	termsError=false;
	showLoginLink=false;
	showSupportLinksSIM=false;

	if(!$form_activate.id) return errors=['Something is wrong, you aren\'t editing an active order. Please start over.'];
	if(!credit_card_valid && !manualTranzilaToken) return errors=['Please enter valid payment information.'];

	errors=[];
	loading=true;

	let myofficeguytoken = null;
	let bestfone_mog; //need to have the variable declared
	let baseOfficeGuyURL = 'https://api.sumit.co.il';

	if(credit_card_valid){ //$form_activate.usa_number_wanted always try saving it
		let Credentials={ //public working credentials
			'CompanyID': "91153118"
			,'APIPublicKey': "wwCMK0NxNcmBYuDzcNJe11ulVnSvgmO4vHD1sw4WXjKvf2enfR"
			};
		if(process.env.NODE_ENV=='test') Credentials = {
			'CompanyID': "95084685"
			,'APIPublicKey': "QZcjC4JSJYMTW7sAYbbRahnkYocUQ1QCvWzJi3FT5tbEgfegWx"
			};

		console.log('attempting to save to myofficeguy');

		const endpoint = baseOfficeGuyURL+'/creditguy/vault/tokenizesingleusejson/';
		const json = {
			Credentials:Credentials
			,CardNumber:credit_card.credit_card_number
			,ExpirationMonth:credit_card.expiry_month
			,ExpirationYear:credit_card.expiry_year
			,CVV:credit_card.security_code
			//,CitizenID:citizenID
			};

		myofficeguytoken = fetch(endpoint, {
			method: "POST"
			,headers: {
				'Content-Type': 'application/json'
				,'Content-Language': 'en'
				}
			,body: JSON.stringify(json)
			})
		.then(response => response.json())
		.then(function(result){
			if(result.Status!=0) {
				console.error(result.UserErrorMessage);
				console.error(result.TechnicalErrorDetails);
				if($form_activate.usa_number_wanted) errors=[...errors, result.UserErrorMessage];
				return null;
				}
			return result.Data.SingleUseToken;
			})
		.catch(console.error);
		}

	if(manualTranzilaToken){//admin filled out
		var token = manualTranzilaToken;
		bestfone_mog = manualMyOfficeGuyCustomer;
		}
	else {
		var token = tokenTranzila.create({
				credit_card_number:credit_card.credit_card_number
				})
			.catch(function(err){
				console.error(err.message);
				errors=[...errors, err.message];
				});
		const results = await Promise.all([token,myofficeguytoken]);
		if(errors.length) return loading=false;

		token = results[0];//save the resolved values
		myofficeguytoken=results[1];
		}

	//let cc_last4 = credit_card.credit_card_number.substr(-4);//for tranzila we just calculate this from the token.
	let cc_expiry=	'' + credit_card.expiry_month + credit_card.expiry_year //MMYY for tranzila
	let security_code = credit_card.security_code;
	success = await sim_activations.patch($form_activate.id, {TranzilaTK:token, cc_expiry, security_code,myofficeguytoken, bestfone_mog})//also submit the price @TODO: should recalc the price server side
		.catch(function(err){
			console.error(err.message);
			if(err.message.includes('Tranzila')) {
				if(err.message.includes('006')){
					ask_security_code=true;
					errors=['Credit card charge failed, please try adding the security code'];
					}
				else errors=['Credit card charge failed'];
				}
			else errors=[err.message];

			if(err.message.includes('Please login')) {
				showLoginLink=true;
				}
			if(err.message.includes('Please contact support')) {
				showSupportLinksSIM=true;
				}
			if(err.message.includes('can\'t modify')) {
				resetID();
				errors.push('Submitting again will create a NEW activation request.')
				}
			});

	loading=false;
	if(errors.length) return;

	//console.log(success);
	if(success.last_billed) {
		//order_id=success.id;
		$form_activate={};//success - reset the form, no more editing
		push('/8');
		var elmnt = document.getElementById("page_title");
		elmnt.scrollIntoView();
		}
	else errors=['Your payment mysteriously failed.'];
	}

function clearCache(){
	localStorage.removeItem('form_order');
	localStorage.removeItem('form_activate');
	}


</script>



<main>
{#if process.env.NODE_ENV=='test'}
	<div class="ribbon">
		<a href="#">Test site!</a>
	</div>
	{/if}

<h2 class="title-1 ff-dunbar fw-800 text-brand" id="page_title">SIM Card Activation <small>(page {$location.replace('/','')})
	{#if $perms && $perms.includes('admin')}
	<button on:click={clearCache} class="btn btn-sm btn-secondary">ADMIN: Clear Cache</button>
	{/if}
</small></h2>
<form>
<br />
{#if $location=='/1' || $location=='/' }
<!-- for true border transitions, need to use css grid. https://svelte.dev/repl/cdd93d1fa5d8435aba8f9b71a34dc02b?version=3.23.2
To make it really move over, need to overflow:hidden (but that ruins the corners) -->
<div transition:slide={{duration:750}} style="text-align:center" class="clearfix">
	{#if refer}
	<span class="ff-dunbar title-2 text-brand">Referred by:</span> <span class="ff-dunbar text-brand" style="font-size: 18px;">{refer}</span>
	<br><br>
	{/if}
	{#if import_order}
	<div class="alert alert-success">Imported sim order for {$form_activate.Customer_Name}</div>
	{/if}

	<h3 class="ff-dunbar title-2" >All plans include:</h3>
	<span class="checks">
	<ul class="ff-stag fw-600 text-black ml-4" style="max-width:400px;display:inline-block;text-align:left">
		<li>Unlimited Calls & Texts to Israeli phone numbers</li>
		<li>Unlimited outgoing calls to USA and Canada and landlines to 33 additional countries <img style="cursor:pointer" src="image/question-circle-o.png" on:click={showCountries} border=0 width=14 height=16 alt="Click to list countries"/></li>
		<li>Unlimited incoming calls and texts from anywhere in the world</li>
	</ul>
	</span>

	<br><br>

	<div class="section-5">
	<div class="row">
		<div class="offer-box">
		<div class="data ff-stag fw-600" on:click={s=>choosePlan('70gb')} style={$form_activate.plan=="70gb" ? 'border: 4px solid #d1223e;transition: border 0.6s linear;cursor: pointer;' : 'border: 4px solid white;cursor: pointer;'}>
			<div class="top bg-gray">
			<span class="number text-black">70 <span>GB</span></span>
			<span class="txt">LTE Internet Data</span>
			</div>
			<div class="bottom bg-brand text-white pb-2">
			<span class="number">59 <span>Shekels</span></span>
			<button type="button" class="btn p-1" style="background-color:#bcbec0;border-radius:14px;">Choose <Fa fw icon={faAngleDoubleRight}/></button>
			</div>
			{#if $form_activate.plan=="70gb"}
				<div class="mt-1 mb-0 top bg-gray" in:send out:receive>
				Chosen! <Fa fw icon={faCheck}/>
				</div>
				{/if}
		</div>
		</div>
		<div class="offer-box">
		<div class="data ff-stag fw-600" on:click={s=>choosePlan('150gb')} style={$form_activate.plan=="150gb" ? 'border: 4px solid #d1223e;transition: border 0.6s linear;cursor: pointer;' : 'border: 4px solid white;cursor: pointer;'}>
			<div class="top bg-gray">
			<span class="number text-black">150 <span>GB</span></span>
			<span class="txt">LTE Internet Data</span>
			</div>
			<div class="bottom bg-brand text-white pb-2">
			<span class="number">79 <span>Shekels</span></span>
			<button type="button" class="btn p-1" style="background-color:#bcbec0;border-radius:14px;">Choose <Fa fw icon={faAngleDoubleRight}/></button>
			</div>
			{#if $form_activate.plan=="150gb"}
				<div class="mt-1 mb-0 top bg-gray" in:send out:receive>
				Chosen! <Fa fw icon={faCheck}/>
				</div>
				{/if}
		</div>
		</div>

		<div class="offer-box">
			<div class="data ff-stag fw-600" on:click={s=>choosePlan('5G-200gb')} style={$form_activate.plan=="5G-200gb" ? 'border: 4px solid #d1223e;transition: border 0.6s linear;cursor: pointer;' : 'border: 4px solid white;cursor: pointer;'}>
				<div class="top bg-gray">
					<span class="number text-black">200 <span>GB</span></span>
					<span class="txt"><b><u>5G</u></b> Internet Data </span>
				</div>
				<div class="bottom bg-brand text-white pb-2">
				<span class="number">99 <span>Shekels</span></span>
				<button type="button" class="btn p-1" style="background-color:#bcbec0;border-radius:14px;">Choose <Fa fw icon={faAngleDoubleRight}/></button>
				</div>
				{#if $form_activate.plan=="5G-200gb"}
					<div class="mt-1 mb-0 top bg-gray" in:send out:receive>
					Chosen! <Fa fw icon={faCheck}/>
					</div>
					{/if}
			</div>
			</div>

		<div class="offer-box" style="margin-left: auto;margin-right: auto;">
		<div class="data ff-stag fw-600" on:click={s=>choosePlan('kosher')} style={$form_activate.plan=="kosher" ? 'border: 4px solid #d1223e;transition: border 0.6s linear;cursor: pointer;' : 'border: 4px solid white;cursor: pointer;'}>
			<div class="top bg-gray">
			<span class="number text-black">KOSHER</span>
			<span class="txt">- Voice Only -</span>
			</div>
			<div class="bottom bg-brand text-white pb-2">
			<span class="number">64 <span>Shekels</span></span>
			<button type="button" class="btn p-1" style="background-color:#bcbec0;border-radius:14px;">Choose <Fa fw icon={faAngleDoubleRight}/></button>
			</div>
			{#if $form_activate.plan=="kosher"}
				<div class="mt-1 mb-0 top bg-gray" in:send out:receive>
				Chosen! <Fa fw icon={faCheck}/>
				</div>
				{/if}
		</div>
		</div>
		</div>
	</div>

{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	</div>
{/if}

<br>
<a href="index.html" class="btn btn-success" style="float:left"><Fa fw icon={faHome}/> Home </a>
<button id="continue1" type="submit" on:click|preventDefault={submitPlan} class="btn btn-success" style="float:right">Continue <Fa fw icon={faAngleDoubleRight}/></button>
<br>
</div>

{:else if $location=='/2'}
<div transition:slide={{duration:750}} class="clearfix">
	<h3 class="ff-dunbar title-2">Are you moving your existing Israeli number from another network?</h3>
	
	<!--<button type="button" class="btn btn-info" class:btn-sm={$form_activate.porting} onclick={s=>$form_activate.porting=true}>I need a new phone number <i show={isPorting===false} class="glyphicon glyphicon-ok"></i></button><br><br>
	<button type="button" class="btn btn-info {'btn-sm':isPorting===false}" onclick={doPorting.bind(null, true)}>Keep my existing Israeli number <i show={isPorting} class="glyphicon glyphicon-ok"></i></button>-->

	<label><input type="radio" bind:group={$form_activate.porting_form} value={false}> I need a new Israeli phone number.</label><br>
	<label><input type="radio" bind:group={$form_activate.porting_form} value={true}> I am porting an <u>active</u> number from another network.</label>
	
	{#if $form_activate.porting_form}
	<div transition:slide={{duration:750}} class="ml-4">
	<label for="porting">Existing Israeli Number: </label>
		<input type="tel" bind:value={$form_activate.porting} id="porting" class="form-control" placeholder="Current Israeli number"
		class:is-valid={israelNumberValid} class:is-invalid={israelNumberValid==false} required
		on:blur={checkisraelNumberStrict} on:keyup={checkisraelNumberLoose} on:keypress={onlyNumbersSeparator}
		>
	</div>
	{/if}



{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	{#if showLoginLink}
		<div transition:slide>
		<br>
		<a href="/login?account={$form_activate.porting}" class="btn btn-info" target="_blank">Login To Your Account</a>
		</div>
		{/if}
	{#if showSupportLinksPort}
		<div transition:slide>
		<br>
		Contact support via WhatsApp at <a href="https://wa.me/972547806284" target="_blank">+972-54-780-6284</a> or email at <a href="mailto:info@freedomhot.com">info@freedomhot.com</a>
		</div>
		{/if}
	</div>
{/if}

<br>
<a href="#/1" class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous Step</a>
<button id="continue2" type="submit" on:click|preventDefault={submitPorting} class="btn btn-success" style="float:right">Continue <Fa fw icon={faAngleDoubleRight}/></button>
</div>



{:else if $location=='/3'}
<div transition:slide={{duration:750}} class="clearfix">
	<h3 class="ff-dunbar title-2">Local USA Number</h3>

	Add a USA number that rings on your phone in Israel for an additional $15 dollars per month.<br>
	<small>Or Canada for $17/month</small>

	<br><br>
	<label><input type="radio" bind:group={$form_activate.usa_number_wanted} value={true}> Yes</label>
		{#if $form_activate.usa_number_wanted}
		<div transition:slide={{duration:750}} class="ml-4">
		
			<b>Choose a Location</b> (if you don't specify, we will set up a New York number)
			<ul class="ml-4 mt-0">
				<li><small>NY, NJ, CA (you will receive your number immediately or within 6 hours)</small></li>
				<li><small>Other Location: (you will receive your number within 12-48 hours)</small></li>
				<li><small>Canada, $17/month: specify area code (you will receive your number within 12-48 hours)</small></li>
			</ul>

			<input type="text" bind:value={$form_activate.usa_number_location} id="usa_number_location" class="form-control" placeholder="Desired Location">
		</div>
		{/if}
	<br>
	<label><input type="radio" bind:group={$form_activate.usa_number_wanted} value={false}> No (maybe later)</label><br>


{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	</div>
{/if}

<br>
<a href="#/2" class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous Step</a>
<button id="continue3" type="submit" on:click|preventDefault={submitVirtualNumber} class="btn btn-success" style="float:right">Continue <Fa fw icon={faAngleDoubleRight}/></button>
<br>
</div>


{:else if $location=='/4'}

<div transition:slide={{duration:750}} class="clearfix">
<h3 class="ff-dunbar title-2">Enter SIM Info</h3>

Please enter the 19-digit number printed on the SIM pack - OR - the 12-digit number printed on the actual SIM card (begins with 899 or 104, 105, or 194)
<br><!--br>
<button class="btn btn-primary"on:click={DecodePictureOfSIM}><Fa icon={faCamera}/> Take a picture of the barcode</button>
<br><br-->
<div class="input-group">
	<div class="input-group-prepend">
	<span class="input-group-text">8997207</span>
	</div>
	 <!--tel ?-->
  <input type="text" pattern="[0-9]*" maxlength=19 inputmode="numeric" style="max-width:300px"
	class="form-control" class:is-valid={simValid} class:is-invalid={simValid==false} required
	bind:value={$form_activate.sim} placeholder="SIM Number" on:blur={checkSimStrict} on:keyup={checkSimLoose} on:keypress={onlyNumbers} />
</div>
	<br />

{#if error_sim_usa||error_sim_canada||error_sim_israel}
	<div class="alert alert-danger">
		<div transition:slide>{error_sim_usa||error_sim_canada||error_sim_israel}</div>
	</div>
{/if}

{#if errors && errors.length}
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{@html error}</div>
	{/each}
	{#if showLoginLink}
		<div transition:slide>
		<br>
		<a href="/login?account={$form_activate.sim}" class="btn btn-info" target="_blank">Login To Your Account</a>
		</div>
		{/if}
	{#if showSupportLinksSIM}
	<div transition:slide>
	<br>
	Contact support via WhatsApp at <a href="https://wa.me/972547806284" target="_blank">+972-54-780-6284</a> or email at <a href="mailto:info@freedomhot.com">info@freedomhot.com</a>
	</div>
	{/if}
	</div>
{/if}


<br>
<button type="button" on:click={function(){errors=[];push('/3');}} class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous Step</button>
<button id="continue4" type="submit" on:click|preventDefault={submitSIM} class="btn btn-success" style="float:right">Continue <Fa fw icon={faAngleDoubleRight}/></button>
<br>
</div>



{:else if $location=='/5'}

<div transition:slide={{duration:750}} class="clearfix">

	<label class="ff-dunbar title-2 text-brand" for="Customer_Name">First and last name of customer: *</label>
		<input type="text" required bind:value={$form_activate.Customer_Name} name="Customer_Name" autocomplete="name" id="Customer_Name" class="form-control" placeholder="First and last name of customer" />

	<br /><label class="ff-dunbar title-2 text-brand" for="email">Email address *</label>
	<input type="text" required bind:value={$form_activate.email} name="email" id="email" class="form-control" placeholder="Email address" on:blur={checkEmailAddress} />
	{#if emailSuggestion}
		<div class="alert alert-danger" align="right"><i>Did you mean <a name="fixEmail" on:click={setEmail}>{emailSuggestion.address}@<b>{emailSuggestion.domain}</b></a>?</i></div>
	{/if}
	
	<br><br>
	{#if $perms && $perms.includes('admin')}
	<div class="alert alert-info">
		SKIPPING EMAIL VERIFICATION
	</div>
	{:else}
	<div class="alert alert-warning">
	<Fa fw icon={faExclamationCircle}/> In order to finish your activation, you will need to access the confirmation code in your email.
	</div>
	{/if}

{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	{#if showLoginLink}
		<div transition:slide>
		<br>
		<a href="/login?account={$form_activate.sim}" class="btn btn-info" target="_blank">Login To Your Account</a>
		</div>
		{/if}
	{#if showSupportLinksSIM}
	<div transition:slide>
	<br>
	Contact support via WhatsApp at <a href="https://wa.me/972547806284" target="_blank">+972-54-780-6284</a> or email at <a href="mailto:info@freedomhot.com">info@freedomhot.com</a>
	</div>
	{/if}
	</div>
{/if}

<br>
<a href="#/4" class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous Step</a>

{#if 0 && $perms && $perms.includes('admin')}
<button type="submit" disabled={loading} on:click|preventDefault={submitEmailWithoutVerification} class="btn btn-success" style="float:center">
	{#if loading} <Spinner /> {/if} ADMIN: skip email verification <Fa fw icon={faAngleDoubleRight}/> 
	</button>
{/if}

<button id="continue5" type="submit" disabled={loading} on:click|preventDefault={submitEmail} class="btn btn-success" style="float:right">
	{#if loading} <Spinner /> {/if} Continue <Fa fw icon={faAngleDoubleRight}/> 
	</button>
<br>
</div>



{:else if $location=='/6'}

<div transition:slide={{duration:750}} class="clearfix">

	<div class="alert alert-info">
	We sent you a 4-digit code to your email address <b>{$form_activate.email}</b><br>
	<br>
	Please enter it to continue.<br>
	</div>
	<br>

	<label for="code">Confirmation code</label> <input type="number" min="0" max="9999" id="code" maxlength=4 bind:value={verification_code}><br>
	<br>
	If you need to get your confirmation code at a different email address, please <a href="#/5">update it here.</a><br>

	{#if errors && errors.length}
		<br />
		<div class="alert alert-danger">
		{#each errors as error}
			<div transition:slide>{error}</div>
		{/each}
		</div>
	{/if}
	<br>
	<a href="#/5" class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous Step</a>
	<button id="continue6" type="submit" disabled={loading} on:click|preventDefault={submitVerification} class="btn btn-success" style="float:right">
	{#if loading} <Spinner /> {/if} Continue <Fa fw icon={faAngleDoubleRight}/> 
	</button>
	<br>

</div>

{:else if $location=='/7'}

<div transition:slide={{duration:750}} class="clearfix">

<div class="alert alert-warning">
	<Fa fw icon={faExclamationCircle}/> IMPORTANT MESSAGE
	<ul class="ml-4">
	<li>Submitting this form will activate your SIM card and start your service <b>IMMEDIATELY</b>.</li>
	<li>This is an <b>ONGOING</b> monthly service, and you will be billed every month until you log in at FreedomHot.com/login and cancel your line.</li>
	</ul>

	<br>
	
	<label class:shake={termsShake} class:text-danger={termsError} class:font-weight-bold={termsError}>
		<input type="checkbox" bind:checked={$form_activate.terms} required>
		I confirm that I have read and agree to the two statements above.
	</label>
	
</div>

<br>

	<CreditCardForm
		bind:credit_card_number={credit_card.credit_card_number} bind:valid={credit_card_valid}
		bind:expiry_month={credit_card.expiry_month} bind:expiry_year={credit_card.expiry_year}
		bind:ask_security_code={ask_security_code} bind:security_code={credit_card.security_code}
		/>
	{#if $perms && $perms.includes('admin')}
		<br><br>
		<div class="row justify-content-md-center">
			<div class="col col-lg-6 alert alert-secondary">
				<b>ADMIN:</b> (fill out expiry in the normal place)<br>
				<input type="text" class="form-control" bind:value={manualTranzilaToken} placeholder="Tranzila Token">
				<input type="text" class="form-control" bind:value={manualMyOfficeGuyCustomer} placeholder="MyOfficeGuy Customer">
			</div>
			</div>
	{/if}
	
	{#if errors && errors.length}<br>
		<div class="alert alert-danger">
		{#each errors as error}
			<div transition:slide>{error}</div>
		{/each}
		{#if showLoginLink}
			<div transition:slide>
			<br>
			<a href="/login?account={$form_activate.sim}" class="btn btn-info" target="_blank">Login To Your Account</a>
			</div>
			{/if}
		{#if showSupportLinksSIM}
			<div transition:slide>
			<br>
			Contact support via WhatsApp at <a href="https://wa.me/972547806284" target="_blank">+972-54-780-6284</a> or email at <a href="mailto:info@freedomhot.com">info@freedomhot.com</a>
			</div>
		{/if}
		</div>
	{/if}
	
	<br>
	<a href="#/5" class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous Step</a><!-- skip past verification (6), we're already verified if we're here-->
	<button id="continue7" type="submit" disabled={loading} on:click|preventDefault={submitPayment} class="btn btn-success" style="float:right">
	{#if loading} <Spinner /> {/if} Activate Now <Fa fw icon={faAngleDoubleRight}/> 
	</button>
	<br>

</div>


{:else if $location=='/8'}

<div transition:slide={{duration:750}} class="clearfix">

<div class="alert alert-success">
	{#if success.fullyActive && success.israel_number}
		<Fa icon={faThumbsUp} /> Your activation was successful!<br><br>
		Check your email for your activation details.<br><br><br>
		<Fa icon={faExclamationCircle} /> If you have already inserted your SIM card into your phone, you must restart your phone in order to pick up service.
	{:else}
		<Fa icon={faThumbsUp} /> Your activation request has been received.<br><br>
		We will be in touch by email within 4 business hours.
	{/if}

</div>

<br><br>
<a href="index.html" class="btn btn-success" style="float:left"><Fa fw icon={faHome}/> Home </a>
<a href="sim-activate.html" class="btn btn-success" style="float:right">Activate another SIM <Fa fw icon={faRedo}/></a>

</div>
{/if}

</form>

<style>
	@keyframes shake {
	  0% { transform: translateX(0); }
	  25% { transform: translateX(-5px); }
	  50% { transform: translateX(5px); }
	  75% { transform: translateX(-5px); }
	  100% { transform: translateX(0); }
	}
  
	.shake {
	  animation: shake 0.5s;
	  animation-iteration-count: 3; /* Repeat the animation 6 times to achieve a 3 second shake */
	}
  </style>
  
  

</main>
